import React, { useState } from 'react'
import { FaTrash, FaCheck, FaPlus } from 'react-icons/fa'
import GuidedTour from '../onboarding/shared/GuidedTour'
import GuidedTourMobile from '../onboarding/shared/GuidedTourMobile'
import { Theme } from '../../lib/theme';
type DesktopActionButtonsProps = {
  onDelete: () => void
  onFinalize: () => void
  onNewVersion: () => void
  finalized: boolean
  currentSlideId?: string
  userPlan: string
  deleteFinalizeDisabled: boolean
  newVersionDisabled: boolean
  isQuickGenerating: boolean
  showEligibilityTooltip:boolean
  pptxUrl?:string
}

export const DesktopButtonSection: React.FC<DesktopActionButtonsProps> = ({
  onDelete,
  onFinalize,
  onNewVersion,
  finalized,
  currentSlideId,
  userPlan,
  deleteFinalizeDisabled,
  newVersionDisabled,
  isQuickGenerating,
  showEligibilityTooltip,
  pptxUrl
}) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [isDialogVisibledelete, setIsDialogVisibledelete] = useState(false)
  const [isDialogVisibleNew, setIsDialogVisibleNew] = useState(false)
  const [ishovered,setishovered]=useState(false);
  const [finalizeToolTip,setFinalizeToolTip] = useState(false)
  const [deleteToolTip,setDeleteToolTip] = useState(false)
  const [newVersionToolTip,setNewVersionToolTip] = useState(false)


  return (
<div className="relative flex gap-2">
  {/* Delete Button */}
  <button
    id="delete"
    onClick={() => setIsDialogVisibledelete(true)}
    disabled={deleteFinalizeDisabled  || newVersionDisabled || !!pptxUrl}
    className={`border p-2 rounded-md flex items-center active:scale-95 transition transform duration-300 disabled:cursor-not-allowed hover:text-red-600  ${!!pptxUrl ? ' cursor-not-allowed' : ''}`}
    style={{
      borderColor: Theme.colors.stroke.weak,
      color: Theme.colors.text.weak,
    }}
  onMouseEnter={() => {
    setDeleteToolTip(true)
  }
    }
    onMouseLeave={() =>{
      setDeleteToolTip(false)
    }}
  >
    <FaTrash className="h-4 w-4 mr-1" style={{ color: Theme.colors.text.weak }} />
    <span className="hidden lg:block">Delete Version</span>
  </button>
    {deleteToolTip && (
        <div
          className="absolute hidden lg:block text-left bottom-12 w-72 p-3 text-xs rounded-lg shadow-lg transition-opacity duration-300 opacity-100 z-10"
          style={{
            backgroundColor: Theme.colors.grounding,
            color: Theme.colors.background,
          }}
        >
          <p className="font-semibold">Delete</p>
          <p>
             Delete the selected slide version from the presentation.
          </p>
        </div>
      )}

  {/* Finalize Button */}
  <button
    id="finalize"
    onClick={onFinalize}
    disabled={deleteFinalizeDisabled || newVersionDisabled || !!pptxUrl}
    className={`p-2 rounded-md flex items-center border active:scale-95 transition transform duration-300 disabled:cursor-not-allowed  ${!!pptxUrl ? ' cursor-not-allowed' : ''}`}
    style={{
      borderColor: currentSlideId && finalized
        ? Theme.colors.button.primary
        : Theme.colors.stroke.weak,
      backgroundColor: currentSlideId && finalized ? "#36fa810a" : "transparent",
    }}
     onMouseEnter={() => {
  setIsDialogVisible(true);
  setFinalizeToolTip(true);
}}

onMouseLeave={() => {
  setIsDialogVisible(false);
  setFinalizeToolTip(false);
}}
  >
    <FaCheck
      className="h-4 w-4 mr-1"
      style={{
        color: finalized ? Theme.colors.button.primary : Theme.colors.text.weak,
      }}
    />
    <span className="hidden lg:block" style={{ color: Theme.colors.text.weak }}>
      Finalize Version
    </span>
  </button>
  {finalizeToolTip && (
        <div
          className="absolute hidden lg:block text-left bottom-12 w-72 p-3 text-xs rounded-lg shadow-lg transition-opacity duration-300 opacity-100 z-10"
          style={{
            backgroundColor: Theme.colors.grounding,
            color: Theme.colors.background,
          }}
        >
          <p className="font-semibold">Finalize</p>
          <p>
             Finalize the selected slide version to add it to the final presentation. Only one slide version can be finalized within a section.
          </p>
        </div>
      )}

  {/* New Version Button */}
  <button
    onClick={onNewVersion}
    id="new-version"
    disabled={newVersionDisabled || !!pptxUrl}
    className={`border p-2 rounded-md flex items-center active:scale-95 transition transform duration-300 disabled:cursor-not-allowed hover:text-blue-600  ${!!pptxUrl ? ' cursor-not-allowed' : ''}`}
    style={{
      borderColor: Theme.colors.primary,
      color: Theme.colors.primary,
    }}
   onMouseEnter={() =>{ 
      setIsDialogVisibleNew(true);
      setNewVersionToolTip(true);

    }}
    onMouseLeave={() => {
       setIsDialogVisibleNew(false);
       setNewVersionToolTip(false)
      }
      }
  >
    <FaPlus className="h-4 w-4 mr-1" style={{ color: Theme.colors.primary }} />
    <span className="hidden lg:block">New Version</span>
  </button>
   {newVersionToolTip && (
        <div
          className="absolute hidden lg:block text-left bottom-12 left-[60%] transform -translate-x-1/4 w-72 p-3 text-xs rounded-lg shadow-lg transition-opacity duration-300 opacity-100 z-10"
          style={{
            backgroundColor: Theme.colors.grounding,
            color: Theme.colors.background,
          }}
        >
          <p className="font-semibold">New Version</p>
          <p>
                            Navigate between different slide versions of the same section          </p>
        </div>
      )}

      {/* Delete Confirmation Dialog */}
      {isDialogVisibledelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Delete Version</h3>
            <p className="text-gray-600 mb-6">Are you sure you want to delete this version? This action cannot be undone.</p>
            <div className="flex gap-3 justify-end">
              <button 
                onClick={() => setIsDialogVisibledelete(false)}
                className="px-4 py-2 text-gray-600 bg-gray-100 rounded hover:bg-gray-200"
              >
                No
              </button>
              <button 
                onClick={() => {
                  onDelete();
                  setIsDialogVisibledelete(false);
                }}
                className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
</div>
  )
}

type MobileActionButtonsProps = {
  onDelete: () => void
  onFinalize: () => void
  onNewVersion: () => void
  finalized: boolean
  currentSlideId?: string
  displayMode: string
  deleteFinalizeDisabled: boolean
  newVersionDisabled: boolean
  isQuickGenerating: boolean
  pptxUrl?:string
}

export const MobileButtonSection: React.FC<MobileActionButtonsProps> = ({
  onDelete,
  onFinalize,
  onNewVersion,
  finalized,
  currentSlideId,
  displayMode,
  deleteFinalizeDisabled,
  newVersionDisabled,
  isQuickGenerating,
  pptxUrl
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  return (
<div className="flex gap-4">
  {/* Delete Button */}
  <button
    id="delete-mobile"
    disabled={deleteFinalizeDisabled  || newVersionDisabled || !!pptxUrl}
    onClick={() => setShowDeleteConfirm(true)}
    className={`border p-2 rounded-md flex items-center disabled:cursor-not-allowed hover:text-red-600 ${!!pptxUrl ? ' cursor-not-allowed' : ''}`}
    style={{
      borderColor: Theme.colors.stroke.weak,
      color: Theme.colors.text.weak,
    }}
  >
    <FaTrash className="h-4 w-4" style={{ color: Theme.colors.text.weak }} />
  </button>

  {/* Finalize Button */}
  <button
    id="finalize-mobile"
    onClick={onFinalize}
    disabled={deleteFinalizeDisabled  || newVersionDisabled || !!pptxUrl}
    className={`border p-2 rounded-md flex items-center disabled:cursor-not-allowed ${!!pptxUrl ? ' cursor-not-allowed' : ''}`}
    style={{
      borderColor:
        currentSlideId && finalized
          ? Theme.colors.button.primary
          : Theme.colors.stroke.weak,
      backgroundColor: currentSlideId && finalized ? "#36fa810a" : "transparent",
    }}
  >
    <FaCheck
      className="h-4 w-4"
      style={{
        color: currentSlideId && finalized
          ? Theme.colors.button.primary
          : Theme.colors.text.weak,
      }}
    />
  </button>

  {/* New Version Button */}
  <button
    id="new-version-mobile"
    onClick={onNewVersion}
    disabled={newVersionDisabled || !!pptxUrl}
    className={`border p-2 rounded-md flex items-center disabled:cursor-not-allowed hover:text-blue-600 ${!!pptxUrl ? ' cursor-not-allowed' : ''}`}
    style={{
      borderColor:
        displayMode === "newContent"
          ? Theme.colors.stroke.weak
          : Theme.colors.primary,
      color:
        displayMode === "newContent"
          ? Theme.colors.text.weak
          : Theme.colors.primary,
    }}
  >
    <FaPlus
      className="h-4 w-4"
      style={{
        color:
          displayMode === "newContent"
            ? Theme.colors.text.weak
            : Theme.colors.primary,
      }}
    />
  </button>

  <GuidedTour />
  <GuidedTourMobile />

  {/* Delete Confirmation Dialog */}
  {showDeleteConfirm && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4">
        <h3 className="text-lg font-semibold mb-4">Delete Version</h3>
        <p className="text-gray-600 mb-6">Are you sure you want to delete this version? This action cannot be undone.</p>
        <div className="flex gap-3 justify-end">
          <button 
            onClick={() => setShowDeleteConfirm(false)}
            className="px-4 py-2 text-gray-600 bg-gray-100 rounded hover:bg-gray-200"
          >
            No
          </button>
          <button 
            onClick={() => {
              onDelete();
              setShowDeleteConfirm(false);
            }}
            className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  )}
</div>
  )
}
